import React, { useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";


const RegistrationForm = () => {


    return (
        <>


        </>
    );
};

export default RegistrationForm;
